import { serializeNodes } from '@plone/volto-slate/editor/render';
import { getAnchor } from '@plone/volto-slate/utils/toc';
import config from '@plone/volto/registry';
import isEqual from 'lodash/isEqual';

const TextBlockView = (props) => {
  const { id, data, styling = {} } = props;
  const { value, override_toc } = data;
  const metadata = props.metadata || props.properties;
  const { topLevelTargetElements } = config.settings.slate;

  const getAttributes = (node, path) => {
    const res = { ...styling };
    if (node.type && isEqual(path, [0])) {
      if (topLevelTargetElements.includes(node.type) || override_toc) {
        res.id = getAnchor(node) || id;
      }
    }
    return res;
  };

  return serializeNodes(value, getAttributes, { metadata: metadata });
};

export default TextBlockView;
